<template>
    <div id="header" role="navigation" 
    data-limit=".15" 
    :class="['section', { 'nav-scroll': isScrolled, 'transparent': isTransparent  }]">
   
        <div class="header-inner">
            <router-link class="navbar-brand" to="/" id="logo" aria-label="JLHSOFT TECHNOLOGY Homepage">
                <img :src="logo" alt="Logo" class="logo-img" />
            </router-link>
            <div class="btn-group" v-if="isMobile">
                    <button class="btn btn-link btn-sm" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                        <i class="bi bi-globe lang-button"></i>
                    </button>
                    <ul class="dropdown-menu dropdown">
                        <li><a class="dropdown-item" href="#" @click.prevent="changeLanguage('en')"><img :src="imgen" alt="English" class="img_lang" width="16" height="11" /> {{ $t('English') }}</a></li>
                        <li><a class="dropdown-item" href="#" @click.prevent="changeLanguage('es')"><img :src="imges" alt="Español" class="img_lang" width="16" height="11" /> {{ $t('Spanish') }}</a></li>
                        <li><a class="dropdown-item" href="#" @click.prevent="changeLanguage('pt')"><img :src="imgbr" alt="Portugués" class="img_lang" width="16" height="11" /> {{ $t('Portuguese') }}</a></li>
                    </ul>
                </div>
            <div id="navigation" v-if="!isMobile">
                <ul class="nav-links">
                    <li class="nav-item"><router-link to="/" aria-label="Home page">{{ $t('Home') }}</router-link></li>
                    <li class="nav-item"><router-link to="/about" aria-label="About page">{{ $t('Who we are?') }}</router-link></li>
                    <li class="nav-item"><router-link to="/services" aria-label="Services page">{{ $t('Services') }}</router-link></li>
                    <li class="nav-item"><router-link to="/works" aria-label="Works page">{{ $t('Works') }}</router-link></li>
                    <li class="nav-item"><router-link to="/contact" aria-label="Contact us page">{{ $t('Contact us') }}</router-link></li>

                </ul>
            </div>
        </div>
        <div id="navigation-right" v-if="!isMobile">
            <ul class="nav-links">
                <!-- <li class="nav-item"><router-link to="#" rel="noopener" aria-label="JLHSOFT shop page" target="_blank">{{ $t('Shop') }}</router-link></li> -->
                <li class="nav-item dropdown">
                    <a class="nav-link" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                        <img :src="langPath" class="img_lang" /> {{ lPath }} <i class="bi bi-caret-down-fill"></i>
                    </a>
                    <ul class="dropdown-menu">
                        <li><a class="dropdown-item" href="#" @click.prevent="changeLanguage('en')"><img :src="imgen" alt="English" class="img_lang" width="16" height="11" /> {{ $t('English') }}</a></li>
                        <li><a class="dropdown-item" href="#" @click.prevent="changeLanguage('es')"><img :src="imges" alt="Español" class="img_lang" width="16" height="11" /> {{ $t('Spanish') }}</a></li>
                        <li><a class="dropdown-item" href="#" @click.prevent="changeLanguage('pt')"><img :src="imgbr" alt="Portugués" class="img_lang" width="16" height="11" /> {{ $t('Portuguese') }}</a></li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>

</template>
<script>
import logo from '../assets/images/logo-light.png';
import imgen from '../assets/lang/us.png';
import imges from '../assets/lang/es.png';
import imgbr from '../assets/lang/br.png';
export default {
    name: 'NavbarComponent',
    data() {
        return {
            logo,
            isScrolled: false,
            isTransparent: true,
            isMobile: false,
            imgen,
            imges,
            imgbr

        };
    },
    computed: {
        logoPath() {
            return this.isScrolled ? this.logoDark : this.logoLight;
        },
        langPath() {
            return this.$i18n.locale === 'en' ? this.imgen : this.$i18n.locale === 'es' ? this.imges : this.imgbr;
        },
        lPath() {
            return this.$i18n.locale === 'en' ? 'EN' : this.$i18n.locale === 'es' ? 'ES' : 'PT';
        },

    },
    mounted() {
        window.addEventListener("scroll", this.handleScroll);
        this.handleResize(); // Verifica el tamaño inicial de la pantalla
        window.addEventListener("resize", this.handleResize); // Escucha cambios en el tamaño
    },
    beforeUnmount() {
        window.removeEventListener("scroll", this.handleScroll);
        window.removeEventListener("resize", this.handleResize); // Limpia el listener al desmontar
    },
    methods: {
        handleScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            this.isScrolled = scrollTop > 100;
            this.isTransparent = scrollTop < 100;
        },
        changeLanguage(lang) {
            // Asegurarse de que $i18n esté definido antes de usarlo
            if (this.$i18n) {
                this.$i18n.locale = lang; // Cambiar idioma dinámicamente
            } else {
                console.error("Vue I18n no está inicializado correctamente.");
            }
        },
        handleResize() {
            this.isMobile = window.innerWidth <= 991; // Cambiar a móvil si la pantalla es menor o igual a 768px
        },
    },
}
</script>

<style scoped>
#header {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    width: 100%;
    height: 100px;
    transition: background-color 0.5s ease;
}
.transparent {
  background-color: transparent !important;
}

#navigation-right, .header-inner {
    -webkit-transition: opacity .2s linear .1s;
    transition: opacity .2s linear .1s;
}

#header.is-hidden {
    pointer-events: none;
}

#header.has-background .header-bg {
    -webkit-transform: none;
    transform: none;
    -webkit-transition-delay: 0s;
    transition-delay: 0s;
}

.header-inner {
    display: block;
    position: relative;
    width: 100%;
    height: 100%;
    max-width: 1400px;
    margin: 0 auto;
    text-align: left;
    left: 85px;
}

#navigation,
#navigation-right {
    position: absolute;
    top: 38px;
    height: 30px;
}

#logo {
    position: absolute;
    top: 32px;
    width: 210px;
    height: auto;
}

#logo img {
    display: block;
    height: 40px;
}

#navigation {
    display: inline-block;
    left: 285px;
}

#navigation-right {
    display: inline-block;
    right: 85px;
}

.nav-links {
    position: relative;
    list-style-type: none;
    margin: 0;
    padding: 0;
}

.nav-links li {
    position: relative;
    display: inline-block;
    margin: 0 12px;
}

.nav-links li a {
    display: block;
    line-height: 1.4;
}

#navigation .nav-links li a:after,
#navigation-right .nav-links li a:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background: #fff;
    -webkit-transform: scaleX(0);
    transform: scaleX(0);
    -webkit-transform-origin: right center;
    transform-origin: right center;
    -webkit-transition: -webkit-transform .6s cubic-bezier(.19, 1, .22, 1);
    transition: -webkit-transform .6s cubic-bezier(.19, 1, .22, 1);
    transition: transform .6s cubic-bezier(.19, 1, .22, 1);
    transition: transform .6s cubic-bezier(.19, 1, .22, 1), -webkit-transform .6s cubic-bezier(.19, 1, .22, 1);
}

#navigation .nav-links li a,
#navigation-right .nav-links li a {
    -webkit-transition: opacity .6s linear;
    transition: opacity .6s linear;
}

#navigation .nav-links li a:hover,
#navigation-right .nav-links li a:hover {
    color: #fff;
}

#navigation .nav-links li a:focus:after,
#navigation .nav-links li a:hover:after,
#navigation-right .nav-links li a:focus:after,
#navigation-right .nav-links li a:hover:after {
    -webkit-transition-duration: .4s;
    transition-duration: .4s;
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
    -webkit-transform-origin: left center;
    transform-origin: left center;
}

.nav-links a {
    position: relative;
    font-family: "Inter", serif;
    font-size: 14px;
    font-weight: 400;
    font-weight: 500;
    font-style: normal;
    color: #fff;
    text-transform: uppercase;
    -webkit-transition: color .25s ease;
    transition: color .25s ease;
    text-shadow: 0px 5px 15px rgb(15 36 84 / 5%);
}


.nav-scroll {
    padding: 0 0 0 0;
    position: fixed;
    top: -100px;
    left: 0;
    width: 100%;
    transition: transform 0.5s ease, background-color 0.5s ease;
    -webkit-transition: -webkit-transform .5s ease;
    transition: -webkit-transform .5s ease;
    -webkit-transform: translateY(0px);
    transform: translateY(0px);
    background-color: #000; 
    -webkit-box-shadow: 0px 5px 15px rgb(15 36 84 / 5%);
    box-shadow: 0px 5px 15px rgb(15 36 84 / 5%);
}


/**Responsive styles here*/
@media screen and (max-width: 991px) {
  #header {
    height: 60px;
    padding: 0 15px;
  }

  .header-inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    left: 0;
  }

  #logo {
    position: relative;
    top: 0;
    left: 0;
    width: auto;
  }

  #logo img {
    height: 40px;
  }

  #navigation,
  #navigation-right {
    display: none; /* Oculta la navegación completa en dispositivos móviles */
  }

  .nav-item.dropdown {
    display: inline-block;
  }

  .nav-item.dropdown .nav-link {
    padding: 0;
    display: flex;
    align-items: center;
  }

  .dropdown-menu {
    position: absolute;
    min-width: 100px;
    right: 0;
  }

  .lang-button{
    color: #fff;
  }
}
</style>